import HypercaciaeaeImage from "../assets/images/Hypericaceae.jpg";
import HawthornPhoto from "../assets/images/Hawthorns.jpeg";
import WillowPhoto from "../assets/images/Willows.jpg";
import FernPhoto from "../assets/images/Ferns.jpg";
import BedstrawPhoto from "../assets/images/Bedstraws.jpg";
import AgrimoniaPhoto from "../assets/images/Agrimonia.webp";
import DichantheliumPhoto from "../assets/images/Dichanthelium.jpeg";
import HelianthusPhoto from "../assets/images/helianthus.webp";
import HeliopsisPhoto from "../assets/images/heliopsis.jpg";
import SilphiumPhoto from "../assets/images/silphium.webp";

import FernLichenPDF from "../assets/files/completed_research/ferns_lycophytes.pdf";
import HypercaiceaePDF from "../assets/files/completed_research/hypericaceae.pdf";
import HawthornsPDF from "../assets/files/completed_research/hawthorns.pdf";
import WillowsPDF from "../assets/files/completed_research/willows.pdf";
import GaliumsPDF from "../assets/files/completed_research/galiums.pdf";
import AgrimoniaPDF from "../assets/files/completed_research/Agrimonia_in_the_Chicago_Region.pdf";
import DichantheliumPDF from "../assets/files/completed_research/Dichanthelium_in_the_Chicago_Region.pdf";
import HelianthusPDF from "../assets/files/completed_research/helianthus.pdf";
import HeliopsisPDF from "../assets/files/completed_research/heliopsis.pdf";
import SilphiumPDF from "../assets/files/completed_research/silphium.pdf";

interface CompletedResearchType {
  title: string;
  description: string;
  image: string;
  pdf?: string;
  link?: string;
}

const CompletedResearch: CompletedResearchType[] = [
  {
    title: "Hypericaceae of the Chicago Region",
    image: HypercaciaeaeImage,
    description:
      "Distribution, Diversity, and Conservation Status of Hypericaceae in the Urban and Suburban Landscapes of the Chicago Region",
    pdf: HypercaiceaePDF,
  },
  {
    title: "Hawthorns of the Chicago Region",
    image: HawthornPhoto,
    description:
      "A Comprehensive Study of Hawthorn (Crataegus) Diversity in the Chicago Region",
    pdf: HawthornsPDF,
  },
  {
    title: "Willows of the Chicago Region",
    image: WillowPhoto,
    description:
      "A Guide to Identifying Willows (Salix) in the Chicago Region: Key Characteristics and Distributions",
    pdf: WillowsPDF,
  },
  {
    title: "Ferns and Lycophytes of the Chicago Region",
    image: FernPhoto,
    description:
      "An Inventory and Ecological Analysis of Ferns and Lycophytes in the Chicago Region",
    pdf: FernLichenPDF,
  },
  {
    title: "Bedstraws of the Chicago Region",
    image: BedstrawPhoto,
    description:
      "The Bedstraw Family (Rubiaceae: Galieae) of the Chicago Region:  A Study in Diversity and Distribution",
    pdf: GaliumsPDF,
  },
  {
    title: "Agrimonia of the Chicago Region",
    image: AgrimoniaPhoto,
    description:
      "A Study of Agrimonia in the Chicago Region: Distribution, Ecology, and Conservation",
    pdf: AgrimoniaPDF,
  },
  {
    title: "Dichanthelium of the Chicago Region",
    image: DichantheliumPhoto,
    description:
      "A Study of Dichanthelium in the Chicago Region: Distribution, Ecology, and Conservation",
    pdf: DichantheliumPDF,
  },
  {
    title: "Helianthus of the Chicago Region",
    image: HelianthusPhoto,
    description:
      "Illustrated Guide to the Annual and Perennial Sunflowers (Helianthus) of the Chicago Region",
    pdf: HelianthusPDF,
  },
  {
    title: "Heliopsis of the Chicago Region",
    image: HeliopsisPhoto,
    description:
      "Illustrated Floral Anatomy of False Sunflower (Heliopsis helianthoides), with a Glossary of Key Terms",
    pdf: HeliopsisPDF,
  },
  {
    title: "Silphium of the Chicago Region",
    image: SilphiumPhoto,
    description:
      "Illustrated Guide to the Rosinweeds, Cup Plant, Compass Plant, and Prairie Dock (Silphium) of the Chicago Region",
    pdf: SilphiumPDF,
  },
];

export default CompletedResearch;
export type { CompletedResearchType };
